<template>
  <div>
    <div
      v-if="componentData.type === 'radio'"
    >
      <FilterComponentRadio
        :elements="componentData.elements"
        :selected.sync="selectedMutable"
        :title="componentData.title"
      />
    </div>

    <div
      v-else-if="componentData.type === 'periodo'"
    >
      <FilterComponentPeriodo
        :elements="componentData.elements"
        :selected.sync="selectedMutable"
        :title="componentData.title"
        :has-others="componentData.hasOthers"
      />
    </div>

    <div
      v-else
    >
      <FilterComponentExemple
        :elements="componentData.elements"
        :selected.sync="selectedMutable"
        :title="componentData.title"
      />
    </div>

  </div>
</template>

<script>

import FilterComponentRadio from '@/components/filterDialog/components/FilterComponentRadio'
import FilterComponentExemple from '@/components/filterDialog/components/FilterComponentExemple'
import FilterComponentPeriodo from '@/components/filterDialog/components/FilterComponentPeriodo'

export default {
  name: 'FilterComponent',
  components: { FilterComponentPeriodo, FilterComponentExemple, FilterComponentRadio },
  props: {
    componentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    selected: {
      type: [Object, Array],
      default: () => {
        return undefined
      }
    }
  },
  watch: {
    selected (newValue) {
      this.setupSelected(newValue)
    },
    selectedMutable () {
      this.$emit('update:selected', this.selectedMutable)
    }
  },
  data () {
    return {
      selectedMutable: []
    }
  },
  created () {
    this.setupSelected(this.selected)
  },
  methods: {
    setupSelected (selected) {
      this.selectedMutable = selected
      // Se o selected for vazio e houver um default, preenche com o default
      if (!selected && this.componentData.default) {
        const defaultStringify = JSON.stringify(this.componentData.default)
        this.selectedMutable = this.componentData.elements.find((el) => {
          return JSON.stringify(el) === defaultStringify
        })
      }
    },
    update () {
      this.$emit('update:selected', { ...this.selectedMutable })
    }
  }
}
</script>

<style scoped>

</style>
